import * as m from 'mithril';
import AppContext from '../context/AppContext';

import { SubFsm } from 'little-fsm';
import { PaymentSelectionFsmScheme } from '../states/payment-selection/PaymentSelectionFsmScheme';
import PaymentSelectionPage from '../pages/paymentselection/PaymentSelectionPage';
import { PaymentSelectionFsmContext } from '../states/payment-selection/PaymentSelectionFsmContext';
import { ApiService } from '../ApiService';
import { ErrorDTO, PaymentIntentCreateRequestDTO, PaymentMethodDTO, PaymentOptionDTO, PromoCodeVerifiedResponseDTO } from '../apiclient/ApiDtos';
import Either from '../types/Either';

export function buildPaymentSelectionPresenter(
    appContext: AppContext,
    apiService: ApiService,
    subFsm: SubFsm<PaymentSelectionFsmScheme>): {
        render: () => m.Vnode
    } {

    let isInitiatingPayment = false;

    subFsm.setEnterEffect('fetching_payment_methods', c => {
        apiService.getPaymentOptions(
            c.tentativeBookingReviewContext.tentativeBooking.billId
        ).then(result => {
            if (result.right) {
                console.log("Got Payment Options..., ", result.right)
                subFsm.processEvent("fetching_payments_succeed", { paymentOptions: result.right })
                m.redraw()
            }

        });
    })

    subFsm.setEnterEffect('applying_promo_code', c => {
        if (c.selectedPayment != null && c.selectedPayment.promoCode != null) {
            let promoCode = c.selectedPayment.promoCode;
            let paymentMethodCode = c.selectedPayment.paymentOption.paymentMethod.code;

            apiService.verifyPromoCode(
                c.tentativeBookingReviewContext.tentativeBooking.billId,
                paymentMethodCode,
                promoCode
            ).then(errorOrResult => {
                console.log("Got promo applied result.", errorOrResult)
                let result: Either<ErrorDTO, PromoCodeVerifiedResponseDTO>;
                if (errorOrResult.right) {
                    result = {
                        left: undefined,
                        right: errorOrResult.right
                    }
                } else {
                    result = {
                        left: {
                            status: 400,
                            title: "Failed.",
                            detail: errorOrResult.left.details,
                            type: ""
                        },
                        right: undefined
                    }
                }
                subFsm.processEvent("promo_verification_finished", {
                    result: result
                })
            });
        } else {
            console.error("Selected Payment Or Promo Code is null." +
                "SelectedPayment:", c.selectedPayment
                , "PromoCode:", c.selectedPayment?.promoCode)
        }

    })

    function initiatePayment(context: PaymentSelectionFsmContext) {
        if (context.selectedPayment != null) {
            isInitiatingPayment = true;
            let paymentMethodCode = context.selectedPayment.paymentOption.paymentMethod.code;
            let promoCodeApplicationRef: string | null = null;
            if (context.selectedPayment.promoAppliedResult != null && context.selectedPayment.promoAppliedResult.right) {
                promoCodeApplicationRef = context.selectedPayment.promoAppliedResult.right.promoCodeVerificationRef
            }
            let paymentRequest: PaymentIntentCreateRequestDTO = {
                billId: context.tentativeBookingReviewContext.tentativeBooking.billId,
                mode: 'WEB',
                paymentMethod: new PaymentMethodDTO(paymentMethodCode),
                promoCodeVerificationRef: (promoCodeApplicationRef != null) ? promoCodeApplicationRef : undefined
            }
            apiService.createPaymentIntent(
                paymentRequest
            ).then(errorOrResult => {
                console.debug("Error: ", errorOrResult.left)
                if (errorOrResult.left) {
                    subFsm.processEvent("duplicate_payment_attempted", {})
                    isInitiatingPayment = false;
                } else {
                    window.location.href = errorOrResult.right.web.payLinkUrl;
                    setTimeout(() => {
                        isInitiatingPayment = false;
                        subFsm.processEvent("promo_removed", {})
                        m.redraw();
                    }, 3000)
                }

            });


            let paymentInitiationTimeoutFor1Min = 60 * 1000;
            setTimeout(() => {
                if (isInitiatingPayment) {
                    isInitiatingPayment = false;
                    m.redraw();
                }
            }, paymentInitiationTimeoutFor1Min)
        } else {
            console.error("Cannot Initiate Payment. Selected Payment is null.")
        }

    }

    return {
        render() {
            let context = subFsm.getCurrentContext();
            let substate = subFsm.getCurrentSubState();

            let promoVerifiedResult = context.selectedPayment ? context.selectedPayment.promoAppliedResult : null;

            if (substate == 'initial') {
                subFsm.processEvent('requested_payment_options', {})
            }

            //let promoAppliedResult : Either< ErrorDTO, PromoCodeVerifiedResponseDTO>;
            //if(con)

            return m(PaymentSelectionPage, {
                appContext: appContext,
                isLoading: substate == 'applying_promo_code' || isInitiatingPayment,
                operator: context.tentativeBookingReviewContext.tentativeBooking.trip.operator,
                tentativeBooking: context.tentativeBookingReviewContext.tentativeBooking,
                paymentOptions: context.paymentOptions,
                selectedPayment: context.selectedPayment,
                promoAppliedResult: promoVerifiedResult,

                onSelectPaymentOption: (paymentOption) => {
                    subFsm.processEvent("payment_selected", {
                        paymentOption: paymentOption
                    })
                },
                onUnselectPaymentOption: () => {
                    if (!isInitiatingPayment) {
                        subFsm.processEvent("selected_payment_closed", {})
                    }
                },
                onApplyPromoCode: (promoCode: string) => {
                    subFsm.processEvent("promo_code_added", { promoCode })
                },
                onRemovePromoCode: () => {
                    subFsm.processEvent("promo_removed", {})
                },
                onInitiatePayment: () => {
                    initiatePayment(context);
                },

                isBacktracking: substate == 'confirming_tentative_booking_lost',
                onBacktrackRequested: () => {
                    subFsm.processEvent('back', {});
                },
                onBacktrackConfirmed: () => {
                    subFsm.processEvent('back_confirmed', {});
                },
                onBacktrackCancelled: () => {
                    subFsm.processEvent('back_cancelled', {});
                }
            })
        }
    }
}